module.exports = __webpack_public_path__ + "static/media/background4.5491aceb.jpg";